<template>
  <div class="lendingSection2">
    <landing-container>
      <div class="lendingSection2__container">
        <public-profile />
        <join-our-community />
        <apps />
        <videos />
      </div>
    </landing-container>
  </div>
</template>

<script>
import LandingContainer from "@/components/Landing/components/LandingContainer.vue";
import PublicProfile from "./PublicProfile.vue";
import JoinOurCommunity from "./JoinOurCommunity.vue";
import Apps from "./Apps.vue";
import Videos from "./Videos.vue";

export default {
  name: "LandingSection2",
  components: {
    LandingContainer,
    PublicProfile,
    JoinOurCommunity,
    Apps,
    Videos,
  },
};
</script>

<style lang="scss" scoped>
.lendingSection2 {
  padding: 0 0 64px;

  background: url("~img/landing/earth-piece2.png") top left no-repeat,
    url("~img/landing/earth-piece1.png") bottom right no-repeat #e2f9ff;

  @media (min-width: $breakpoint-xl) {
    padding: 0 16px 96px;
  }

  &__container {
    margin-top: -144px;
    background-color: #ffffff;

    @media (min-width: $breakpoint-xl) {
      margin-top: -188x;
    }
  }
}
</style>
